const labelClass = 'mb-1.5 block text-sm font-medium text-slate-700';

export default function ColorField({ id, label, value, onChange }) {
  return (
    <div>
      <label htmlFor={id} className={labelClass}>
        {label}
      </label>
      <div className="flex items-center gap-3">
        <input
          id={id}
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-10 w-14 cursor-pointer rounded-lg border border-slate-200 bg-white p-1"
        />
        <span className="font-mono text-sm text-slate-600">{value}</span>
      </div>
    </div>
  );
}
